export default __webpack_public_path__ + "static/media/clothing_light.4592fa8c.png";